import React, { useState, useEffect, useRef } from "react";
import { CircularProgress } from "@mui/material";
import { BiSolidQuoteAltLeft } from "react-icons/bi";
import { Clock, Lock, Mail, UserRound,X } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import host from "../../global";
import { candidateAuthHeader } from "../../utils/candidateAuth";
import { ScheduleMeeting } from "react-schedule-meeting";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import { SiGooglecalendar } from "react-icons/si";
import { FaMicrosoft } from "react-icons/fa";
import { FaApple } from "react-icons/fa";
import CancelInterviewModal from "../../components/shared_components/CancelInterviewModal";
import "./ScheduleTest.css";
import InterviewPortalCalendar from "./InterviewPortalCalendar";

import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber, getCountries } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { getWhiteLabelFromInterview } from "../../utils/whitelabel";
import { useDispatch, useSelector } from "react-redux";
import { updateData } from "../../store/slices/miscSlice";
import BrandingFooter from "../../components/shared/BrandingFooter";
import { normalizePhone } from "../../utils/phone";
import { useTheme } from "../../hooks/useTheme";
// import "./scheduleTestPage.css";

export default function Component() {
  const [jobRole, setJobRole] = useState("");
  const { interview_id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isScheduling, setIsScheduling] = useState(false);
  const [errors, setErrors] = useState({});
  const [jobDescription, setJobDescription] = useState("");
  const [startdate, setStartdate] = useState(null);
  const [enddate, setEnddate] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [isCancelConfirmOpen, setIsCancelConfirmOpen] = useState(false);
  const [resendCount, setResendCount] = useState(0);

  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    interviewID: interview_id,
    email: "",
  });
  const [interviewTime, setInterviewTime] = useState(null);
  const [countdown, setCountdown] = useState(null);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  const storedOtpState = JSON.parse(sessionStorage.getItem(`otpState_${interview_id}`) || '{}');
  const [otpSent, setOtpSent] = useState(storedOtpState.otpSent || false);
  const [otpValue, setOtpValue] = useState(["", "", "", "", "", ""]);
  const [otpTimer, setOtpTimer] = useState(Math.max(0, Math.floor(((storedOtpState.timerExpiry || 0) - Date.now()) / 1000)));
  const [emailVerified, setEmailVerified] = useState(storedOtpState.emailVerified || false);
  const otpTimerRef = useRef(null);
  
  const [defaultCountry, setDefaultCountry] = useState(null);
  const [isCanceled, setIsCanceled] = useState(false);
  const { theme, toggleTheme } = useTheme();

  const whitelabelEnabled = useSelector((state)=>state.miscSlice.whitelabelEnabled)
  // const [isWhiteLabelingEnable, setisWhiteLabelingEnable] = useState(JSON.parse(localStorage.getItem("isWhite")));
  console.log({whitelabelEnabled})
  const otpInputRef = useRef([]);

  // Redux States
  const data = useSelector((state)=>state.miscSlice)
  console.log({data})
  const dispatch = useDispatch();


  useEffect(() => {
    const detectCountry = async () => {
      try {
        const { data } = await axios.get("https://ipapi.co/json/", {
          timeout: 3000,
        });
        const code = data.country_code?.toUpperCase();
        if (code && getCountries().includes(code)) {
          setDefaultCountry(code);
        }
      } catch (e) {
        console.warn("IP geolocation failed, using fallback");
      }
    };
    detectCountry();
  }, []);

  // Resume OTP countdown timer on page load if there's remaining time
  useEffect(() => {
    if (otpTimer > 0 && !otpTimerRef.current) {
      otpTimerRef.current = setInterval(() => {
        setOtpTimer((prev) => {
          if (prev <= 1) {
            clearInterval(otpTimerRef.current);
            otpTimerRef.current = null;
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => {
      if (otpTimerRef.current) {
        clearInterval(otpTimerRef.current);
      }
    };
  }, []);
  const startOtpCountdown = () => {
    setOtpTimer(60);
    otpTimerRef.current = setInterval(() => {
      setOtpTimer((prev) => {
        if (prev <= 1) {
          clearInterval(otpTimerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const saveOtpState = (updates) => {
    const current = JSON.parse(sessionStorage.getItem(`otpState_${interview_id}`) || '{}');
    sessionStorage.setItem(`otpState_${interview_id}`, JSON.stringify({ ...current, ...updates }));
  };

  const handleSendOtp = async () => {
    setIsSendingOtp(true);
    setOtpSent(true);
    try {
      await axios.post(`${host}/candidate/send_otp`, { email: formData.email });
      toast.success("OTP sent to your email. Check your inbox or spam folder.");
      // setOtpSent(true);
      setResendCount((prev) => prev + 1);
      saveOtpState({ otpSent: true, timerExpiry: Date.now() + 60 * 1000 });
      startOtpCountdown();
    } catch (e) {
      console.error("Error sending OTP:", e);
      const errorMsg =
        e.response?.data?.detail || "Could not send OTP. Please try again.";
      toast.error(errorMsg);
    } finally {
      setIsSendingOtp(false);
    }
  };

  const handleVerifyOtp = async (otpToSend) => {
    setOtpError(""); 
    if (otpToSend.length !== 6) {
      setOtpError("Enter a 6-digit OTP.");
      return;
    }
    try {
      const { data } = await axios.post(`${host}/candidate/verify_otp`, {
        email: formData.email,
        otp: otpToSend,
        interview_id: interview_id,
      });
      if (data.candidate_token) {
        sessionStorage.setItem(`candidateToken_${interview_id}`, data.candidate_token);
      }
      setTimeout(() => {
        setEmailVerified(true);
        saveOtpState({ emailVerified: true, otpSent: false, timerExpiry: 0 });
      }, 1000);
      clearInterval(otpTimerRef.current);
      otpTimerRef.current = null;
    } catch (e) {
      console.error("Error verifying OTP:", e);
      const errorMsg = e.response?.data?.detail || "OTP verification failed.";
      if (errorMsg === "Incorrect or Expired OTP" && resendCount > 1) {
        setOtpError(
          "This OTP is no longer valid. Please use the latest OTP sent."
        );
      } else if (errorMsg.includes("expired or not found")) {
        setOtpError("The OTP has expired. Please request a new one.");
      } else {
        setOtpError(errorMsg);
      }
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "contact") {
      const numbersOnly = value.replace(/\D/g, "");
      setFormData({
        ...formData,
        [name]: numbersOnly,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    const newErrors = { ...errors };
    delete newErrors[name];
    setErrors(newErrors);
  };

  const navigate = useNavigate();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 60000);

    return () => clearInterval(intervalId);
  }, []);

  const roundToNextThirtyMinutes = (date) => {
    let minutes = date.getMinutes();
    let roundedMinutes = Math.ceil(minutes / 30) * 30;
    if (roundedMinutes === 60) {
      date.setHours(date.getHours() + 1);
      roundedMinutes = 0;
    }
    date.setMinutes(roundedMinutes + 30);
    date.setSeconds(0);
    date.setMilliseconds(0);
    // console.log(date);
    return date;
  };

  useEffect(() => {
    if (!interviewTime) {
      return;
    }

    const updateCountdown = () => {
      const now = new Date();
      const timeDifference = interviewTime - now;

      if (timeDifference > 0) {
        const hours = Math.floor(
          (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
        setCountdown(`${hours}h ${minutes}m ${seconds}s`);
      } else {
        setCountdown(null);
        // Only auto-advance if this tab already holds a live candidate_token —
        // otherwise this would skip OTP entirely (not just pre-fill it) for
        // the most common resume case: opening the link after the slot has
        // already started.
        if (
          now >= startdate &&
          now <= enddate &&
          sessionStorage.getItem(`candidateToken_${interview_id}`)
        ) {
          navigate(`/candidate/${interview_id}/testhomepage`, {
            state: { candidateName: formData.name },
          });
        }
      }
    };

    updateCountdown();
    const intervalId = setInterval(updateCountdown, 1000);

    return () => clearInterval(intervalId);
  }, [
    interviewTime,
    formData.name,
    interview_id,
    navigate,
    startdate,
    enddate,
  ]);

  const openScheduleModal = (event) => {
    event.preventDefault();
    if (interviewTime || validateForm()) {
      setIsScheduleModalOpen(true);
    } else {
      toast.warn("Please fill in all the required fields correctly.");
    }
  };

  const handleStartTimeSelect = (startTimeEventEmit) => {
    const selectedTime = startTimeEventEmit.startTime;

    // console.log("=== CANDIDATE TIME SELECTION LOGS ===");
    // console.log("Selected time from calendar:", selectedTime);
    // console.log("Selected time in ISO format:", selectedTime.toISOString());
    // console.log("Selected time in local string:", selectedTime.toString());
    // console.log("Timezone offset (minutes):", selectedTime.getTimezoneOffset());
    // console.log("Timezone:", Intl.DateTimeFormat().resolvedOptions().timeZone);
    // console.log("=====================================");
    setSelectedDate(selectedTime);
    handleSubmit(selectedTime);
  };

  const handleSubmit = async (date) => {
    setIsScheduling(true);
    const dateToUse = date instanceof Date ? date : selectedDate;
    if (!dateToUse) {
      toast.warn("Please select a date and time before submitting.");
      setIsScheduling(false);
      return;
    }

    const formattedDate = dateToUse.toISOString();
    try {
      const cleanContact = formData.contact ? String(formData.contact).replace(/[^\d+]/g, "") : "";

      await axios.patch(`${host}/save_candidateinfo`, null, {
        params: {
          interview_id: interview_id,
          contact_number: cleanContact,
          name: formData.name,
          interview_scheduled_time: formattedDate,
        },
        headers: candidateAuthHeader(interview_id),
      });

      const response = await axios.post(
        `${host}/candidate/schedule_test/${interview_id}/${formattedDate}`,
        null,
        {
          params: { candidate_email: formData.email },
        }
      );
      if (response.status === 200) {
        setIsSubmitClicked(true);
        setIsScheduleModalOpen(false);
        setInterviewTime(new Date(formattedDate));
        toast.success("Interview Scheduled Successfully!");
      } else {
        toast.error("Failed to submit the schedule.");
      }
    } catch (err) {
      toast.error("Failed to submit the schedule.");
    } finally {
      setIsScheduling(false);
    }
  };
  
  const handleCancelInterview = () => {
    setIsCancelConfirmOpen(true);
  };

  const performCancelInterview = async (reason, comment) => {
    try {
      const response = await axios.delete(`${host}/deletecandidate_data`, {
        params: {
          interview_id: interview_id,
          canceled_by_candidate: true,
          cancellation_reason: reason,
          cancellation_comment: comment || '',
        },
        headers: candidateAuthHeader(interview_id),
      });

      if (response.status === 200) {
        toast.success("Interview cancelled successfully.");
        setIsCanceled(true);
      } else {
        toast.error("Failed to cancel the interview.");
      }
    } catch (err) {
      console.error("Error cancelling interview:", err);
      toast.error("An error occurred while cancelling the interview.");
    }
    setIsCancelConfirmOpen(false);
  };
  
  const handleSubmitCandidateData = async (event) => {
    event.preventDefault();

    if (!startdate || !enddate || currentDateTime < startdate) {
      toast.warn(
        "The interview cannot be started yet. Please wait until the scheduled start time."
      );
      return;
    }
    if (currentDateTime > enddate) {
      toast.error("The scheduled interview time has expired.");
      return;
    }
    const data = new FormData();
    data.append("name", formData.name);
    data.append("contact", formData.contact);
    data.append("interviewID", formData.interviewID);
    data.append("interview_scheduled_time", currentDateTime);
    const cleanContact = formData.contact ? String(formData.contact).replace(/[^\d+]/g, "") : "";
    try {
      await axios.patch(`${host}/save_candidateinfo`, null, {
        params: {
          interview_id: formData.interviewID,
          contact_number: cleanContact,
          name: formData.name,
          interview_scheduled_time: currentDateTime.toISOString(),
        },
        headers: candidateAuthHeader(formData.interviewID),
      });
      toast.success("Candidate information updated successfully!");
      setTimeout(() => {
        navigate(`/candidate/${interview_id}/testhomepage`, {
          state: { candidateName: formData.name },
        });
      }, 2000);
    } catch (error) {
      if (error.response) {
        toast.error(
          error.response.data.detail ||
            "An error occurred while submitting the form."
        );
      } else if (error.request) {
        toast.error(
          "No response received from the server. Please check your connection."
        );
      } else {
        toast.error("Error: " + error.message);
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Email address is invalid";
    if (!formData.contact) newErrors.contact = "Phone number is required";
    else if (!isValidPhoneNumber(formData.contact))
      newErrors.contact = "Phone number is invalid";

    if (!emailVerified) newErrors.email = "Email must be verified";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleStartInterview = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    if (!emailVerified) {
      toast.warn("Please verify your email before starting the interview.");
      return;
    }
    if (!startdate || !enddate || currentDateTime < startdate) {
      toast.warn(
        "The interview cannot be started yet. Please wait until the scheduled start time."
      );
      return;
    }
    if (currentDateTime > enddate) {
      toast.error("The scheduled interview time has expired.");
      return;
    }
    handleSubmitCandidateData(e);
  };
  const createCalendarLink = (type) => {
    if (!selectedDate) return "#";
    const eventTitle = `Test Schedule for ${jobRole}`;
    const eventDescription = jobDescription;
    const eventLocation = "";
    const startDateTime = new Date(selectedDate);
    const endDateTime = new Date(startDateTime);
    endDateTime.setHours(startDateTime.getHours() + 2);

    const formatDate = (date, isApple) => {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      const hours = String(date.getUTCHours()).padStart(2, "0");
      const minutes = String(date.getUTCMinutes()).padStart(2, "0");
      return isApple
        ? `${year}${month}${day}T${hours}${minutes}00Z`
        : `${year}-${month}-${day}T${hours}:${minutes}:00`;
    };

    const startDateTimeStr = formatDate(startDateTime, type === "apple");
    const endDateTimeStr = formatDate(endDateTime, type === "apple");

    switch (type) {
      case "google":
        return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
          eventTitle
        )}&dates=${startDateTimeStr}/${endDateTimeStr}&details=${encodeURIComponent(
          eventDescription
        )}&location=${encodeURIComponent(eventLocation)}`;
      case "outlook":
        return `https://outlook.office.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(
          eventTitle
        )}&startdt=${startDateTimeStr}&enddt=${endDateTimeStr}&body=${encodeURIComponent(
          eventDescription
        )}&location=${encodeURIComponent(eventLocation)}`;
      case "apple":
        return `webcal://www.apple.com/calendar/compose.ics?subject=${encodeURIComponent(
          eventTitle
        )}&start=${startDateTimeStr}&end=${endDateTimeStr}&description=${encodeURIComponent(
          eventDescription
        )}&location=${encodeURIComponent(eventLocation)}`;
      default:
        return "#";
    }
  };

  const handleOtpChange = (e, index) => {
    const { value } = e.target;

    // Only allow digits
    if (value.match(/^\d$/)) {
      const newOtp = [...otpValue];
      newOtp[index] = value;
      setOtpValue(newOtp);

      // Move to next input if not last
      if (index < otpValue.length - 1) {
        otpInputRef.current[index + 1].focus();
      }

      // Join OTP and call submit if length === 6
      const otpToSend = newOtp.join("");
      console.log({ otpValue });
      console.log("Handle change called");
      if (otpToSend.length === 6) {
        console.log("Handle Verify Otp Called");
        handleVerifyOtp(otpToSend);
      }
    }

    // If user deletes the value, go to previous input
    if (value === "" && index >= 0) {
      const newOtp = [...otpValue];
      newOtp[index] = "";
      setOtpValue(newOtp);
      // otpInputRef.current[index - 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (!otpValue[index] && index > 0) {
        otpInputRef.current[index - 1].focus();
      } else {
        otpInputRef.current[index].focus();
      }
    }
    setOtpError("");
  };

  useEffect(() => {
    otpInputRef.current[0]?.focus();
  }, []);

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 6);

    if (pasted.length > 0) {
      const newOtp = pasted
        .split("")
        .concat(...Array(6).fill(""))
        .slice(0, 6);
      setOtpValue(newOtp);

      // Focus last filled input
      const lastIndex = Math.min(pasted.length - 1, 5);
      setTimeout(() => otpInputRef.current[lastIndex]?.focus(), 0);
    }

    if (pasted.length === 6) {
      handleVerifyOtp(pasted);
    }
  };

  useEffect(() => {
    const fetchInterviewAndTimeframe = async () => {
      try {
        const response = await axios.get(
          `${host}/get_test_timeframe/${interview_id}`
        );
        const {
          candidate_name,
          candidate_email,
          candidate_contact,
          interview_scheduled_time,
          job_role,
          job_description,
          start_date,
          end_date,
          message,
          is_canceled,
          canceled_by_candidate,
        } = response.data;

        if (is_canceled || canceled_by_candidate) {
          setIsCanceled(true);
        }

        if (message) {
          toast.warning(message);
        }

        if (interview_scheduled_time) {
          setInterviewTime(new Date(interview_scheduled_time));
          // Only skip OTP if this tab already holds a live candidate_token for
          // this interview (same-session continuation). A fresh session (new
          // tab, new day) has no token yet, so it must re-verify via OTP —
          // otherwise every protected candidate-flow call downstream (starting
          // with greet_user) would 401 with nothing to recover from.
          if (sessionStorage.getItem(`candidateToken_${interview_id}`)) {
            setEmailVerified(true);
          }
        }
        setFormData((prevFormData) => ({
          ...prevFormData,
          name: candidate_name,
          email: candidate_email,
          contact: normalizePhone(candidate_contact),
        }));

        setJobRole(job_role);
        setJobDescription(job_description);

        const start = new Date(start_date);
        const end = new Date(end_date);
        setStartdate(start);
        setEnddate(end);
      } catch (error) {
        if (error.response?.status === 403) {
          setIsCanceled(true);
        } else {
          const errorMessage =
            error.response?.data?.detail || "Failed to fetch interview details.";
          toast.error(errorMessage);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchInterviewAndTimeframe();
  }, [interview_id]);

  const isInterviewAvailable =
    startdate &&
    enddate &&
    currentDateTime >= startdate &&
    currentDateTime <= enddate;


  return (
    <div className={`schedule-test-root h-full ${theme === 'dark' ? 'dark-theme' : 'light-theme'}`}>
      <div
        style={{ zoom: 0.9, height: "calc(100dvh / 0.9)" }}
        className={`h-full overflow-hidden w-full flex flex-col gap-2 sm:gap-3 p-2 sm:p-4 pb-0 ${theme === 'light' ? "bg-[#FAF9F6]" : "app-background"
          }`}
      >
        <div className="flex flex-col sm:flex-row flex-1 min-h-0 gap-2 bg-transparent">
          {/* Left Section */}
          {!isCanceled && (
            <div
              className={`hidden sm:flex sm:w-5/12 flex-col justify-center items-center px-4 py-6 rounded-3xl gap-4 p-6 ${
                theme === 'light'
                  ? " bg-white shadow-sm"
                  : "glass-effect shadow-xl"
              }`}
            >
              <img
                src="/congrats-img.png"
                className="h-[130px] w-[110px]"
                alt="Congrats"
              />
              <h1
                className={`font-sans text-2xl md:text-2xl font-bold text-center ${
                  theme === 'light' ? "text-slate-800" : "text-gray-200"
                }`}
              >
                CONGRATULATIONS
              </h1>
              <p
                className={`font-sans text-lg  text-center max-w-sm ${
                  theme === 'light' ? "text-gray-700" : "text-gray-400 "
                }`}
              >
                Your profile got shortlisted for <br /> the position of {jobRole}
              </p>
            </div>
          )}

          {/* Right Section */}
          <div
            className={`flex-1 min-h-0 overflow-y-auto ${!isCanceled ? "sm:w-7/12" : "sm:w-full"} px-4 py-4 sm:py-6 flex flex-col justify-center items-center gap-4 sm:gap-5 rounded-3xl p-4 sm:p-6 ${
              theme === 'light'
                ? "bg-white shadow-sm"
                : "glass-effect  shadow-xl"
            }`}
          >
            {countdown && !isCanceled && emailVerified ? (
              <>
                <div className="relative bg-gradient-to-br from-[#0952DA] to-[#3ECFDA] backdrop-blur-lg rounded-xl p-6 shadow-2xl overflow-hidden border border-white/20">
                  <div className="absolute top-0 left-0 w-24 h-24 bg-[#3ECFDA]/30 rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2"></div>
                  <div className="absolute bottom-0 right-0 w-24 h-24 bg-[#0952DA]/30 rounded-full blur-3xl"></div>
                  <div className="relative z-10 text-center">
                    <div className="flex items-center justify-center mb-4 space-x-2">
                      <Clock
                        className="w-6 h-6 text-white animate-pulse"
                        strokeWidth={1.5}
                      />
                      <h2 className="text-xl font-bold text-white font-sans">
                        Countdown to Test
                      </h2>
                    </div>
                    <div className="bg-gradient-to-r from-white/20 to-white/10 backdrop-blur-sm rounded-xl p-4 mb-3 border border-white/20 shadow-lg">
                      <p className="font-sans text-3xl font-bold text-white tracking-wider animate-pulse-slow">
                        {countdown}
                      </p>
                    </div>
                    <div className="flex items-center justify-center mt-2">
                      <div className="relative">
                        <div className="w-2 h-2 bg-[#3ECFDA] rounded-full"></div>
                        <div className="absolute inset-0 w-2 h-2 bg-[#3ECFDA] rounded-full animate-ping"></div>
                      </div>
                      <p className="text-white/90 text-sm font-medium ml-2 font-sans">
                        Time remaining
                      </p>
                    </div>
                  </div>
                </div>
                <button
                  className="button !px-6 !py-1.5 text-lg  !text-white transition-colors"
                  onClick={() =>
                    navigate(`/candidate/${interview_id}/testhomepage`)
                  }
                >
                  <span className="text-white">Start Now</span>
                </button>
                <button
                  className={`text-sm hover:scale-[102%] transition-transform bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent`}
                  onClick={openScheduleModal}
                >
                  Reschedule Interview
                </button>
              </>
            ) : (
              <>
                 <h2
                  className={`font-sans text-2xl font-semibold tracking-wide text-center w-full ${
                    theme === 'light' ? "text-slate-800" : "text-gray-400"
                  }`}
                >
                   {isCanceled ? "" : "Candidate Details"} <br />
                   {!isCanceled && <p  className="mx-auto px-16 text-xs font-light">* All fields are required </p>}
                </h2>
                {isLoading ? (
                  <CircularProgress />
                ) : isCanceled ? (
                  <div className="w-[100%] max-w-2xl -mt-20 p-16 rounded-3xl border border-gray-200 bg-gray-50 dark:bg-gray-900 dark:border-gray-800/20 text-center space-y-4">
                    <Lock className="w-16 h-16 mx-auto text-red-400" />
                    <h2 className="text-xl font-bold text-gray-900 dark:text-white">Interview Cancelled</h2>
                    <p className="text-md text-gray-500 dark:text-gray-400">
                      This interview has been cancelled. Please contact your recruiter if you think this is a mistake.
                    </p>
                  </div>
                ) : (
                  <form className="w-[80%] max-w-lg ">
                    
                    {/* NAME INPUT */}
                    <div
                      className={`w-4/5 mx-auto mb-4 flex border  rounded-full items-center px-2 ${
                        theme === 'light'
                          ? " border-gray-400"
                          : "border-gray-500"
                      }`}
                    >
                      <UserRound
                        className={`size-5 mx-2  ${
                          theme === 'light'
                            ? "text-gray-800"
                            : "text-[#CCCCCCE5]"
                        }`}
                      />
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        placeholder="Name"
                        onChange={handleInputChange}
                        disabled
                        className={`w-full h-9 pr-4 text-sm rounded-full bg-transparent cursor-not-allowed ${
                          theme === 'light'
                            ? "text-gray-800 placeholder:text-gray-700"
                            : "text-white placeholder:text-gray-400"
                        }`}
                      />
                      {errors.name && (
                        <p className="text-red-600 text-sm pl-3">
                          {errors.name}
                        </p>
                      )}
                    </div>
                    <div>
                      <PhoneInput
                        international
                        defaultCountry={defaultCountry}
                        value={formData.contact}
                        onChange={(value) => {
                          setFormData((prev) => ({
                            ...prev,
                            contact: value || "",
                          }));
                          const newErrors = { ...errors };
                          delete newErrors.contact;
                          setErrors(newErrors);
                        }}
                        placeholder="Enter phone number"
                        flags={true}
                        className={`text-sm w-full h-9 px-4 rounded-full bg-transparent border 
                          ${
                            theme === 'light'
                              ? "border-gray-400"
                              : "border-gray-500"
                          }
                        `}
                        countryCallingCodeEditable={true}
                        countrySelectComponent={({
                          value,
                          iconComponent: Icon,
                        }) => (
                          <div className="pointer-events-none flex items-center mr-1">
                            {Icon && <Icon country={value} />}
                          </div>
                        )}
                      />

                      {errors.contact && (
                        <p className="text-red-600 text-sm pl-16 pb-4">
                          {errors.contact}
                        </p>
                      )}
                    </div>

                    {/* EMAIL ROW */}
                    <div className="w-4/5 mx-auto mb-1 flex border border-gray-500 rounded-full items-center justify-center px-2 pr-1">
                      <Mail
                        className={`size-6 mx-2  ${
                          theme === 'light'
                            ? "text-gray-800"
                            : "text-[#CCCCCCE5]"
                        }`}
                      />
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        disabled
                        className={`w-full h-9 pr-4 text-sm rounded-full bg-transparent cursor-not-allowed ${
                          theme === 'light'
                            ? "text-gray-800 placeholder:text-gray-700"
                            : "text-white placeholder:text-gray-400"
                        }`}
                      />
                      {!emailVerified && (
                        <button
                          type="button"
                          onClick={()=>handleSendOtp()}
                          disabled={otpTimer !== 0}
                          className={`h-7 rounded-full !text-xs whitespace-nowrap flex items-center ${
                            otpTimer != 0 
                          } ${
                            theme === 'light'
                              ? "border-btn !text-textPrimary "
                              : "bg-[#4A1457] text-white px-4"
                          }`}
                          // className={'button m-1 h-7 text-center items-center flex'}
                        >
                          <span>
                            {otpTimer === 0
                            ? "Send OTP"
                            : `Resend in ${otpTimer}s`}
                          </span>
                          
                        </button>
                      )}
                      {emailVerified && (
                        <span className="flex flex-row items-center self-center text-green-500 font-semibold mr-2">
                          ✓<span className="text-xs ml-2">verified</span>
                        </span>
                      )}
                    </div>
                    {errors.email && (
                      <p className="text-red-600 text-sm pl-3 py-2 w-4/5 mx-auto">
                        {errors.email}
                      </p>
                    )}
                    {/* OTP input */}
                    <div className="w-4/5 mx-auto flex flex-col mt-2  items-center">
                      {otpSent && !emailVerified && (
                        <div className="w-full mt-2  flex flex-row space-x-6 items-center justify-center">
                          {otpValue.length > 0 &&
                            otpValue.map((val, index) => (
                              <input
                                key={index}
                                type="text"
                                maxLength="1"
                                onPaste={index === 0 ? handlePaste : undefined}
                                value={val}
                                onChange={(e) => handleOtpChange(e, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                ref={(el) => (otpInputRef.current[index] = el)}
                                className={`w-11 h-11 px-4 rounded-lg border border-gray-500 bg-transparent text-center ${
                                  otpError ? "ring-1 ring-red-500" : ""
                                } ${
                                  emailVerified ? "ring-1 ring-green-500" : ""
                                } ${
                                  theme === 'light'
                                    ? "text-gray-700 placeholder:text-gray-400"
                                    : " text-white placeholder:text-gray-400"
                                }`}
                              />
                            ))}
                        </div>
                      )}
                      {otpError && (
                        <p className="text-red-500 text-sm pl-3 mt-1 w-4/5 px-4">
                          {otpError}
                        </p>
                      )}
                    </div>

                    <div className="flex flex-col gap-4 mt-6 w-4/5 mx-auto">
                      {/* Start Interview Button */}
                      <div className="flex gap-6 w-full">
                      <button
                        disabled={!isInterviewAvailable}
                        className={`h-[40px] w-full rounded-[50px] font-sans text-[14px]
                          transition-colors text-white flex items-center justify-center

                          ${
                            theme === 'light'
                              ? `${
                                  emailVerified && isInterviewAvailable
                                    ? "button border-transparent"
                                    : "cursor-not-allowed bg-gray-300"
                                }`
                              : `${
                                  emailVerified && isInterviewAvailable
                                    ? "bg-[#0A1518] hover:bg-[#0A1518]/90 button"
                                    : "cursor-not-allowed bg-gray-500 hover:bg-gray-600"
                                }`
                          }
                        `}
                        onClick={handleStartInterview}
                        title={
                          !startdate || !enddate || currentDateTime < startdate
                            ? "The interview cannot be started yet. Please wait until the scheduled start time."
                            : currentDateTime > enddate
                              ? "The scheduled interview time has expired."
                              : !formData.contact || !isValidPhoneNumber(formData.contact)
                                ? "Please enter a valid phone number."
                                : !emailVerified
                                  ? "Please verify your email before starting the interview."
                                  : ""
                        }
                      >
                        <span>Start Interview</span>
                      </button>
                      <button
                          disabled={!isInterviewAvailable}
                          className={`h-[40px] w-full rounded-[50px] font-sans text-[15px]
                        transition-colors flex items-center justify-center
                        ${
                          theme === 'light'
                            ? `${
                                emailVerified
                                  ? "border-btn border-transparent !text-gray-700"
                                  : "cursor-not-allowed bg-gray-300 border-transparent !text-white"
                              }`
                            : `${
                                emailVerified
                                  ? "button hover:bg-[#0A1518]/10 hover:border-transparent"
                                  : "cursor-not-allowed bg-gray-500 hover:bg-gray-600 !text-white"
                              }`
                        }
                      `}
                          onClick={openScheduleModal}
                        >
                          <span>Reschedule Interview</span>
                        </button>
                      </div>
                      <div className="flex gap-3 w-full">
                        {/* Cancel Interview Button */}
                        {/* <button
                          type="button"
                          className={`h-[40px] w-full rounded-[50px] font-sans text-[15px]
                            transition-colors flex items-center justify-center border border-gray-500
                            ${theme === 'light'? 'text-black' : 'text-white'}
                            hover:bg-red-500 hover:text-white`}
                          onClick={handleCancelInterview}
                        >
                          <span>Cancel Interview</span>
                        </button> */}
                        {/* Reschedule Interview Button */}
                        {/* <button
                          disabled={!isInterviewAvailable}
                          className={`h-[40px] w-full rounded-[50px] font-sans text-[15px]
                        transition-colors flex items-center justify-center
                        ${
                          theme === 'light'
                            ? `${
                                emailVerified
                                  ? "border-btn border-transparent !text-gray-700"
                                  : "cursor-not-allowed bg-gray-300 border-transparent !text-white"
                              }`
                            : `${
                                emailVerified
                                  ? "button hover:bg-[#0A1518]/10 hover:border-transparent"
                                  : "cursor-not-allowed bg-gray-500 hover:bg-gray-600 !text-white"
                              }`
                        }
                      `}
                          onClick={openScheduleModal}
                        >
                          <span>Reschedule Interview</span>
                        </button> */}
                        
                      </div>
                    </div>
                  </form>
                )}
              </>
            )}
          </div>
        </div>

        {/* Quote Section */}
        {!isCanceled && (
          <div className={`hidden sm:block w-full py-4 mb-4 px-4 rounded-t-3xl p-6 ${theme === 'light' ? 'bg-white shadow-sm':'shadow-xl  glass-effect'}`}>
            <div className="max-w-4xl mx-auto text-center ">
              <BiSolidQuoteAltLeft className={`w-8 h-8 mx-auto mb-4 ${theme === 'light' ? 'text-gray-800 opacity-80' :'text-gray-600 opacity-50'}`} />
              <p className={`text-lg md:text-lg font-sans mb-3 ${theme === 'light' ? 'text-gray-800 ':'text-gray-300 '}`}>
                "I believed, and still believe, that you can build your dreams
                brick by brick. That you can accomplish anything with
                persistence."
              </p>
              <p className="text-base md:text-sm font-sans text-gray-700">
                - Maurene Goo
              </p>
            </div>
          </div>
        )}

        {/* Modals */}
        <Modal
          isOpen={isScheduleModalOpen}
          onRequestClose={() => setIsScheduleModalOpen(false)}
          className="max-w-5xl min-w-3xl mx-auto p-3 rounded-lg bg-none overflow-y-auto"
          overlayClassName="fixed inset-0 bg-black/70 backdrop-blur-md z-40 flex items-center justify-center"
          style={{ zIndex: 9999 }}
        >
          <div
            className={`custom-scheduler-modal ${theme === "light" ? "white-label bg-[#FFFDFD]" : "app-background"
              } p-4 rounded-2xl relative`}
          >
            {/* X Close icon */}
            <button
              onClick={() => setIsScheduleModalOpen(false)}
              className={`absolute top-4 right-4 p-2 rounded-full transition-colors ${theme === 'dark' ? 'text-white hover:bg-white/10' : 'text-gray-800 hover:bg-black/5'} z-50`}
            >
              <X size={24} />
            </button>

            {/* Title */}
            <h2 className={`calendar-header-title ${theme === 'dark' ? 'text-white' : 'text-gray-900'} p-4`}>Reschedule Interview</h2>

            {/* Calendar */}
            <InterviewPortalCalendar
              availableTimeslots={[
                {
                  startTime: roundToNextThirtyMinutes(new Date(startdate)),
                  endTime: roundToNextThirtyMinutes(new Date(enddate)),
                },
              ]}
              onStartTimeSelect={handleStartTimeSelect}
              minDate={new Date()}
              maxDate={enddate}
              theme={theme}
            />
          </div>
        </Modal>
        <Modal
          isOpen={isSubmitClicked}
          onRequestClose={() => setIsSubmitClicked(false)}
          className="max-w-md mx-auto mt-20 p-6 bg-white rounded-lg"
          overlayClassName="fixed inset-0 bg-black/50"
        >
          <p className="text-center mb-6">
            Your test schedule has been submitted successfully and an email has
            been sent!
          </p>

          <div className="flex justify-center gap-8 mb-6">
            {["google", "outlook", "apple"].map((calendar) => (
              <a
                key={calendar}
                href={createCalendarLink(calendar)}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                {calendar === "google" && (
                  <SiGooglecalendar className="w-[54px] h-[54px] text-[#4285F4]" />
                )}
                {calendar === "outlook" && (
                  <FaMicrosoft className="w-[54px] h-[54px] text-[#0078D4]" />
                )}
                {calendar === "apple" && (
                  <FaApple className="w-[54px] h-[54px] text-[#000000]" />
                )}
              </a>
            ))}
          </div>
          <button
            onClick={() => window.location.reload()}
            className="w-full py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Close
          </button>
        </Modal>
        <CancelInterviewModal
          isOpen={isCancelConfirmOpen}
          onClose={() => setIsCancelConfirmOpen(false)}
          onConfirm={performCancelInterview}
          candidateName={formData.name}
        />
        <BrandingFooter />
      </div>
    </div>
  );
}
